import { useState } from 'react'

// Firebase utilities
import { db } from '../../../../utils/firebase'

// UI components
import Input from '../../../ui/inputs/input'

// Returns the markup for the _dev tab when editing a course
export default function CourseDev({ courseDocID, course }) {
    const [courseID, setCourseID] = useState(course?.bs2_id_course || '')
    const [altCourseIDs, setAltCourseIDs] = useState(course?.bs2_id_course_alternates || '')

    // On input focus blur, save the new course ID into the document
    const saveCourseID = async () => {
        console.log("Saving...")

        let altIDs = []

        if (typeof altCourseIDs === "string" && altCourseIDs.length > 0) {
            altIDs = altCourseIDs.split(",")
        }

        await db.doc(`CMS_courses/${courseDocID}`).set({
            bs2_id_course: courseID ?? null,
            bs2_id_course_alternates: altIDs ?? null
        }, { merge:true })

        console.log("Done!")
    }

    return (
        <div style={{ width: "395px" }}>
            <Input
                label="bs2_id_course"
                showLabel={true}
                value={courseID}
                onChange={setCourseID}
                placeholder=" "
                onBlur={() => saveCourseID()} />
            <br />
            <Input
                label="bs2_id_course_alternates"
                showLabel={true}
                value={altCourseIDs}
                onChange={setAltCourseIDs}
                placeholder=" "
                onBlur={() => saveCourseID()} />
            <br />
        </div>
    )
}
